// extracted by mini-css-extract-plugin
export var fadeInOut = "_2k-3";
export var icon = "_2k-4";
export var savedIndicator = "_2k-2";
export var savingIndicator = "_2k-0";
export var spin = "_2k-1";